import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Eye, EyeOff } from "lucide-react";
import { qrtLogin, setQrtSession, getQrtToken } from "../../apis/qrtAdmin";
import logo from "../../assets/i3.png";

const QrtLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  if (getQrtToken()) {
    navigate("/qrt/overview", { replace: true });
  }

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) return;
    setBusy(true);
    setError("");
    try {
      const res = await qrtLogin(email.trim(), password);
      const { token, admin } = res.data?.data || {};
      setQrtSession(token, admin);
      navigate("/qrt/overview", { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="qrt-login">
      <form className="qrt-login-card" onSubmit={submit}>
        <img src={logo} alt="BluTec Ping" className="qrt-login-logo" />
        <h1>BluTec Ping</h1>
        <p className="qrt-login-sub">Admin panel · authorized access only</p>

        {error && <div className="ping-banner red qrt-login-err">{error}</div>}

        <label>
          Email
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            autoFocus
            required
          />
        </label>
        <label>
          Password
          <span className="qrt-login-pass">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              className="qrt-login-eye"
              onClick={() => setShowPassword((v) => !v)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </span>
        </label>

        <button type="submit" className="ping-btn ping-btn-green" disabled={busy}>
          {busy && <Loader2 size={16} className="animate-spin" />}
          Sign in
        </button>
      </form>
    </div>
  );
};

export default QrtLogin;
